import React from 'react';
import PropTypes from 'prop-types';
import withData from '@bd/bdcore-data';
import { get, uniq } from 'lodash';
import LightBox from '@bd/bdui-lightbox';
import { buildThumbnailUrl } from '@bd/bdcore-utilities';
import { css } from '@bd/bdui-styles/emotion';

import PageHelmet from '@bd/bdcore-pagehelmet';

import Header from '../../components/Header';
import Footer from '../../components/Footer';
import InsideHeader from '../../components/InsideHeader';
import PageIntroBanner from '../../components/PageIntroBanner';
import MenuAbout from '../../components/MenuAbout';
// import Gallery from '../Gallery';

const styles = css`
  padding: 40px 0;
  .Gallery_title {
    font-family: $font-family-serif;
    color: #000000;
    font-size: 28px;
    line-height: 1.3;
    text-align: center;
    @media (min-width: 768px) {
      font-size: 40px;
      margin: 0;
    }
  }
  .PhotoGallery_list {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    padding-bottom: 40px;
    .Gallery_item {
      width: 300px;
      height: 220px;
      margin: 10px;
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;

      .Gallery_overlay {
        background-color: rgba(0, 0, 0, 0.4);
        padding: 20px;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        color: #FFFFFF;
        transition: all .3s ease-out;
        &:hover {
          background-color: rgba(0, 0, 0, 0.8);
          transition: all .3s ease-out;
        }
        .Gallery_overlayTitle {
          color: #FFFFFF;
          font-weight: 700;
          position: relative;
          margin-bottom: 20px;
          text-transform: uppercase;
          text-align: center;
          &::after {
            content: '';
            position: absolute;
            bottom: -10px;
            left: 50%;
            transform: translateX(-50%);
            width: 65px;
            height: 2px;
            background-color: #d16637;
          }
        }
      }
    }
  }
  .GalleryCat_wrapper {
    display: flex;
    padding: 0 40px 40px;
    justify-content: center;
    flex-wrap: wrap;
    .GalleryCat_item {
      background-color: rgba(233, 233, 233, 0.44);
      border: 1px solid #D7D7D9;
      margin: 10px;
      height: 45px;
      padding: 5px 20px;
      font-weight: 700;
      display: flex;
      align-items: center;
      cursor: pointer;
      transition: all .3s ease-out;
      &:hover {
        background-color: rgba(0, 68, 106, 1);
        color: #FFFFFF;
        transition: all .3s ease-out;
      }
      &:focus {
        outline: none;
      }
    }
    .ActiveTab {
      background-color: rgba(0, 68, 106, 1);
      color: #FFFFFF;
    }
  }
`;

class GalleryPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      collection: 0,
    };
  }

  changeCollection = index => {
    this.setState({ collection: index });
  }

  render() {
    const { page } = this.props;
    const { collection } = this.state;
    if (!page) {
      return null;
    }
    const category = page.gallery[collection];

    return (
      <div className={styles}>
        <InsideHeader h1="Gallery" background={get(page, 'page_image.contentUrl')} />
        <PageHelmet page={page} />
        <Header />
        <MenuAbout />
        {
          get(page.intro_banner[0], 'paragraph') &&
          <PageIntroBanner
            h2={page.intro_banner[0].top_headline}
            h3={page.intro_banner[0].main_headline}
            h4=""
            p={page.intro_banner[0].paragraph}
            background={get(page, 'intro_banner[0].photo.contentUrl')}
          />
        }
        <div className="container GalleryCat_wrapper">
          {
            get(page, 'gallery').map((item, i) => (
              <span
                key={get(item, 'collection_name')}
                onClick={() => this.changeCollection(i)}
                role="button"
                tabIndex={0}
                className={`GalleryCat_item ${collection === i && 'ActiveTab'}`}
              >
                {get(item, 'collection_name')}
              </span>
            ))
          }
        </div>
        <div className="container">
          <h3 className="Gallery_title mb-4">{get(category, 'collection_name')}</h3>
          <div className="PhotoGallery_list">
            {
              get(category, 'gallery').map(item => (
                <LightBox
                  show={12}
                  items={uniq(get(item, 'images'))}
                  key={get(item, 'name')}
                >
                  <div className="Gallery_item" style={{ backgroundImage: `url(${buildThumbnailUrl(item.images[0].contentUrl, { width: 400, height: 400 })})` }} >
                    <div className="Gallery_overlay">
                      <h4 className="Gallery_overlayTitle">
                        {get(item, 'name')}
                      </h4>
                      {get(item, 'images').length}&nbsp;{get(item, 'images').length > 1 ? 'Images' : 'Image' }
                    </div>
                  </div>
                </LightBox>
              ))
            }
          </div>
        </div>

        {/* <Gallery
          videos={get(page, 'video_gallery', [])}
          categories={get(page, 'gallery', [])}
        /> */}
        <Footer />
      </div>
    );
  }
}

GalleryPage.propTypes = {
  page: PropTypes.object,
};

GalleryPage.defaultProps = {
  page: undefined,
};

export default withData({
  page: 'galleries',
})(GalleryPage);



// WEBPACK FOOTER //
// ./src/pages/GalleryPage/index.js